import fetch from "isomorphic-fetch";
//import { actionTypes as formActions } from 'redux-form';
// import jwtdecode from 'jwt-decode';
// import config from '../../config';
// import { formatUrl } from '../../helpers/ApiClient';
import { fetchStart, fetchResponse, fetchError } from "./fetch.js";

/**
 * Constants
 **/

export const SIGNIN_START = "auth/SIGNIN_START";
export const SIGNIN_SUCCESS = "auth/SIGNIN_SUCCESS";
export const SIGNIN_ERROR = "auth/SIGNIN_ERROR";
export const LOGOUT_SUCCESS = "auth/LOGOUT_SUCCESS";

/**
 * Reducer
 **/

const restoreToken = () => {
  if (typeof localStorage !== "undefined") {
    const token = localStorage.getItem("token")
    return token === "null" ? null : token
  }
}
const saveToken = token => {
  if (token) localStorage.setItem("token", token)
}

const initialState = {
  loggedOut: true,
  token: null,
  error: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "@@INIT":
      return {
        ...state,
        token: restoreToken() || "",
      }
    case LOGOUT_SUCCESS:
      typeof localStorage !== "undefined" && localStorage.removeItem("token"); // eslint-disable-line no-unused-expressions
      return {
        ...state,
        loggedOut: true,
        error: null,
        token: null,
      }
    case SIGNIN_START:
      return {
        ...state,
        token: "",
      }
    case SIGNIN_SUCCESS:
      typeof localStorage !== "undefined" && saveToken(action.token); // eslint-disable-line no-unused-expressions
      return {
        ...state,
        loggedOut: false,
        token: action.token,
        error: null,
      }
    case SIGNIN_ERROR:
      return {
        ...state,
        error: action.error,
      }
    // case UPDATE_PROFILE:
    //   return {
    //     ...state,
    //     profileError: null,
    //   };
    // case UPDATE_PROFILE_SUCCESS:
    //   return {
    //     ...state,
    //     profile: action.result,
    //     profileError: null,
    //   };
    // case UPDATE_PROFILE_FAIL:
    //   return {
    //     ...state,
    //     profileError: action.error,
    //   };
    // case RESET_PROFILE_ERROR:
    //   return {
    //     ...state,
    //     profileError: null,
    //   };
    default:
      return state;
  }
}

/**
 * Action Creators
 **/

export const signinStart = () => ({
  type: SIGNIN_START,
});

export const signinSuccess = payload => ({
  type: SIGNIN_SUCCESS,
  token: payload.token,
});

export const signinError = error => ({
  type: SIGNIN_ERROR,
  error,
});

const siginWithResponse = (dispatch, response) => {
  dispatch(fetchResponse(response));
  if (response.status === 200) {
    response.json().then(
      json => {
        const payload = {
          token: json.token,
        }
        dispatch(signinSuccess(payload))
      },
      err => dispatch(signinError(err)),
    )
  } 
  else
  {
    response.json().then(json => dispatch(signinError(json)))
  }
}

export const signinWithPassword = (email, password) => dispatch => {
  //const path = formatUrl("/token");

  dispatch(signinStart());
  dispatch(fetchStart("signinWithPassword"));
  return fetch("/api/auth", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email,
      password: password,
    }),
  }).then(response => siginWithResponse(dispatch, response), error => dispatch(fetchError(error)));
};

export const logoutSucces = () => ({
  type: LOGOUT_SUCCESS,
});

export const logout = () => dispatch => {
  dispatch(logoutSucces());
};



// WEBPACK FOOTER //
// ./src/redux/ducks/auth.js